import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { userId: Number }
  static targets = ["content", "loading", "error"]

  connect() {
    this.loadSummary()
  }

  async loadSummary() {
    try {
      this.showLoading()
      
      // Simuliere eine Verzögerung für bessere UX
      await new Promise(resolve => setTimeout(resolve, 1500))
      
      // Zeige die statischen Inhalte an, die bereits im HTML vorhanden sind
      this.showContent()
      
    } catch (error) {
      this.showFallback()
    }
  }

  showContent() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('hidden')
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
    }
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('hidden')
    }
  }

  showLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('hidden')
    }
    if (this.hasContentTarget) {
      this.contentTarget.classList.add('hidden')
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
    }
  }

  renderSummary(data) {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('hidden')
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
    }
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('hidden')
      this.contentTarget.innerHTML = this.buildSummaryHTML(data)
    }
  }

  renderSummaryFromHTML(html) {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('hidden')
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
    }
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('hidden')
      this.contentTarget.innerHTML = html
    }
  }

  showFallback() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('hidden')
    }
    if (this.hasContentTarget) {
      this.contentTarget.classList.add('hidden')
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove('hidden')
    }
  }

  // Methode für den "Erneut versuchen" Button
  retryLoadSummary() {
    this.loadSummary()
  }

  buildSummaryHTML(data) {
    let html = `
      <h3 class="text-lg font-semibold mb-3">
        ${data.greeting}
        <span class="text-sm font-normal opacity-75"> - ${data.date}</span>
      </h3>
    `

    // Priority Actions
    if (data.priority_actions && data.priority_actions.length > 0) {
      html += `
        <div class="priority-actions mb-4">
          <h4 class="text-sm font-semibold mb-2 text-yellow-200">🎯 Prioritäten für heute</h4>
          <div class="space-y-2">
      `
      
      data.priority_actions.forEach(action => {
        html += `
          <div class="priority-item bg-white bg-opacity-20 rounded-lg p-3">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <div class="priority-icon text-lg">${action.icon}</div>
                <div class="priority-content">
                  <div class="priority-title text-sm font-medium">${action.title}</div>
                  <div class="priority-description text-xs opacity-75">${action.description}</div>
                </div>
              </div>
              <a href="${action.url}" class="bg-white bg-opacity-20 hover:bg-opacity-30 text-xs px-3 py-1 rounded-full transition-all duration-200">
                ${action.action}
              </a>
            </div>
          </div>
        `
      })
      
      html += `
          </div>
        </div>
      `
    }

    // Quick Wins
    if (data.quick_wins && data.quick_wins.length > 0) {
      html += `
        <div class="quick-wins mb-4">
          <h4 class="text-sm font-semibold mb-2 text-green-200">⚡ Schnelle Erfolge</h4>
          <div class="flex flex-wrap gap-2">
      `
      
      data.quick_wins.forEach(win => {
        html += `
          <a href="${win.url}" class="bg-white bg-opacity-20 hover:bg-opacity-30 text-xs px-3 py-2 rounded-full transition-all duration-200 flex items-center gap-1">
            <span>${win.icon}</span>
            <span>${win.title}</span>
          </a>
        `
      })
      
      html += `
          </div>
        </div>
      `
    }

    // Meetings Today
    if (data.meetings_today && data.meetings_today.length > 0) {
      html += `
        <div class="meetings-today mb-4">
          <h4 class="text-sm font-semibold mb-2 text-blue-200">📅 Termine heute</h4>
          <div class="space-y-1">
      `
      
      data.meetings_today.forEach(meeting => {
        html += `
          <div class="meeting-item text-xs opacity-90">${meeting}</div>
        `
      })
      
      html += `
          </div>
        </div>
      `
    }

    // Motivation
    if (data.motivation) {
      html += `
        <div class="motivation text-sm opacity-90 italic">${data.motivation}</div>
      `
    }

    return html
  }
}
